module.exports = __webpack_public_path__ + "media/images/dashboard/dark/tile_icon_adwords_top_keywords-f02ad307c6047f5fe647f584c52bd744.png";